export default Object.freeze({
  Recurring: 1,
  OneTime: 2,
});
